import VersionManagerCore from '../versionManager.js';
import { pgVersionManager } from '../proGalleryVersionManager';
var LayoutsVersionManager = /** @class */ (function () {
    function LayoutsVersionManager(proGallertVersionManager) {
        this.pgVersionManager = proGallertVersionManager || pgVersionManager;
    }
    LayoutsVersionManager.prototype.allowFixedColumnsInMasonry = function () {
        return (this.pgVersionManager.getVersion('layouts') !==
            VersionManagerCore.Versions.min);
    };
    return LayoutsVersionManager;
}());
export { LayoutsVersionManager };
export default new LayoutsVersionManager();
//# sourceMappingURL=layouts.js.map